module.exports = __webpack_public_path__ + "media/landing_page/instacart-logo-kale-06a6d6bc.svg";